/** Carousel Shelf: Cards layout. Uses the theme's existing Slick dependency. */
(function ($) {
    /* =========================================================
       Initialise one carousel
       Scope all controls to this block; avoid double initialisation.
       ========================================================= */
    function initCardCarousel(scope) {
        const $scope = $(scope);
        const $slider = $scope.find('[data-card-carousel-slider]');
        const $nav = $scope.find('[data-card-carousel-nav]');
        const $buttons = $scope.find('[data-card-carousel-go-to]');
        if (!$slider.length || $slider.hasClass('slick-initialized') || !$.fn.slick) {
            return;
        }
        const count = $slider.children().length;
        if (!count) {
            return;
        }
        const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

        /* =====================================================
           Navigation state
           The selected label represents the leading card.
           Hide controls when every card already fits on screen.
           ===================================================== */
        function syncNavigation(slick, currentSlide) {
            $nav.prop('hidden', count <= slick.options.slidesToShow);
            $buttons.removeClass('is-active').removeAttr('aria-current');
            $buttons.filter('[data-card-carousel-go-to="' + currentSlide + '"]')
                .addClass('is-active').attr('aria-current', 'true');
        }
        $slider.on('init reInit afterChange breakpoint', function (event, slick, currentSlide) {
            syncNavigation(slick, typeof currentSlide === 'number' ? currentSlide : slick.currentSlide);
        });

        /* =====================================================
           Slick settings
           Advance one card at a time; mobile shows one card.
           Infinite mode lets each label become the leading card.
           ===================================================== */
        $slider.slick({
            slidesToShow: Math.min(2, count),
            slidesToScroll: 1,
            infinite: count > 2,
            arrows: false,
            dots: false,
            autoplay: false,
            fade: false,
            speed: reducedMotion ? 0 : 500,
            accessibility: true,
            adaptiveHeight: false,
            swipe: true,
            draggable: true,
            responsive: [{
                breakpoint: 768,
                settings: { slidesToShow: 1, slidesToScroll: 1, infinite: count > 1 }
            }]
        });

        /* =====================================================
           Label buttons
           Direct selection can travel across several cards.
           ===================================================== */
        $buttons.on('click', function () {
            const index = Number($(this).attr('data-card-carousel-go-to'));
            if (Number.isInteger(index) && index >= 0 && index < count) {
                $slider.slick('slickGoTo', index);
            }
        });
    }

    /* =========================================================
       Frontend
       The editor uses a static card grid for straightforward editing.
       ========================================================= */
    $(function () {
        $('[data-card-carousel]').each(function () {
            initCardCarousel(this);
        });
    });
})(jQuery);
